
import { CalculatorCategory } from '@/lib/types/calculator.types';

export const healthCategory: CalculatorCategory = {
  id: 'health-wellness',
  name: 'Health & Wellness',
  description: 'Health, fitness, and nutrition calculators',
  theme: 'health',
  icon: 'heart',
  calculators: [
    {
      id: 'bmi',
      name: 'BMI Calculator',
      description: 'Calculate your Body Mass Index',
      theme: 'health'
    },
    {
      id: 'bmr',
      name: 'BMR Calculator',
      description: 'Calculate your Basal Metabolic Rate',
      theme: 'health'
    },
    {
      id: 'calories',
      name: 'Calorie Calculator',
      description: 'Calculate daily calorie needs',
      theme: 'health'
    },
    {
      id: 'macro',
      name: 'Macro Calculator',
      description: 'Calculate macronutrient breakdown',
      theme: 'health'
    },
    {
      id: 'protein',
      name: 'Protein Calculator',
      description: 'Calculate daily protein requirements',
      theme: 'health'
    },
    {
      id: 'tdee',
      name: 'TDEE Calculator',
      description: 'Calculate Total Daily Energy Expenditure',
      theme: 'health'
    },
    {
      id: 'bodyfat',
      name: 'Body Fat Calculator',
      description: 'Calculate body fat percentage',
      theme: 'health'
    },
    {
      id: 'ideal-weight',
      name: 'Ideal Weight Calculator',
      description: 'Calculate your ideal body weight',
      theme: 'health'
    },
    {
      id: 'sleep',
      name: 'Sleep Calculator',
      description: 'Calculate optimal sleep and wake times',
      theme: 'health'
    },
    {
      id: 'water-intake',
      name: 'Water Intake Calculator',
      description: 'Calculate daily water requirements',
      theme: 'health'
    },
    {
      id: 'due-date',
      name: 'Due Date Calculator',
      description: 'Calculate pregnancy due date',
      theme: 'health'
    },
    {
      id: 'ovulation',
      name: 'Ovulation Calculator',
      description: 'Track ovulation and fertility',
      theme: 'health'
    },
    {
      id: 'conception',
      name: 'Conception Calculator',
      description: 'Calculate conception date',
      theme: 'health'
    },
    {
      id: 'pregnancy',
      name: 'Pregnancy Calculator',
      description: 'Track pregnancy progress',
      theme: 'health'
    }
  ]
};

export default healthCategory;
